import { useEffect, useId, useState } from 'react'
import { api } from '../../api/client'

export default function EngagementAssignmentHistory({engagementId, companyId, companyName}: {engagementId: string; companyId: string; companyName: string}) {
  const [open, setOpen] = useState(false)
  const [offset, setOffset] = useState(0)
  const [attempt, setAttempt] = useState(0)
  const [data, setData] = useState<Awaited<ReturnType<typeof api.engagementCompanyRevisions>> | null>(null)
  const [error, setError] = useState('')
  const panelId = useId()
  useEffect(() => {
    if (!open) return
    let live = true
    api.engagementCompanyRevisions(engagementId, companyId, offset).then(value => { if (live) { setData(value); setError('') } }).catch(e => { if (live) setError(e instanceof Error ? e.message : 'Could not load assignment history') })
    return () => { live = false }
  }, [engagementId, companyId, open, offset, attempt])
  function page(value: number) { setData(null); setError(''); setOffset(value) }
  return <>
    <button className="btn secondary small" aria-expanded={open} aria-controls={panelId} aria-label={`${open ? 'Hide' : 'View'} assignment history for ${companyName}`} onClick={() => { setData(null); setError(''); setOpen(!open) }}>{open ? 'Hide assignment history' : 'Assignment history'}</button>
    {open && <div id={panelId} role="region" aria-label={`Assignment history for ${companyName}`}>
      {error && <p className="notice crit" role="alert">{error}</p>}
      {!data && !error && <p className="muted">Loading assignment history…</p>}
      {data && <>
        <ol className="form-steps">{data.rows.map(row => <li key={`${row.row_id}:${row.revision}`}>
          <strong>Revision {row.revision} · Criteria version {row.schema_version}</strong>
          <p>{row.actor} · {new Date(row.created_at).toLocaleString()}</p><p>{row.reason}</p>
          <details><summary>Schema hash</summary><code>{row.schema_hash}</code></details>
        </li>)}</ol>
        {!data.rows.length && <p className="muted">No revisions on this page.</p>}
        <div className="action-group"><button className="btn secondary small" disabled={offset === 0} onClick={() => page(Math.max(0, offset - 25))}>Newer revisions</button><span>{data.total} revisions</span><button className="btn secondary small" disabled={offset + 25 >= data.total} onClick={() => page(offset + 25)}>Older revisions</button></div>
      </>}
      {error && <button className="btn secondary small" onClick={() => { setError(''); setAttempt(value => value + 1) }}>Retry history</button>}
    </div>}
  </>
}
